 var _class;
import React, {Component,} from 'react'








const TruncatedEllipsis = (setEditorState) => (_class =
  class TruncatedEllipsisClass extends Component {constructor(...args) { super(...args); _class.prototype.__init.call(this); }
    __init() {this.onClick = () => {
      const {contentState, entityKey} = this.props
      const {value} = contentState.getEntity(entityKey).getData()
      setEditorState && setEditorState(value)
    }}

    render() {
      const {offsetkey, children} = this.props
      return (
        React.createElement('span', { 'data-offset-key': offsetkey, style: {cursor: 'pointer'}, onClick: this.onClick,}
          , children
        )
      )
    }
  }, _class)

export default TruncatedEllipsis
